import React from 'react';

//sitewise layer icon
const RotationIcon = () => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="currentColor"
    >
        <path d="M18.5714 0H1.42857C1.04969 0 0.686328 0.15051 0.418419 0.418419C0.15051 0.686328 0 1.04969 0 1.42857L0 18.5714C0 18.9503 0.15051 19.3137 0.418419 19.5816C0.686328 19.8495 1.04969 20 1.42857 20H18.5714C18.9503 20 19.3137 19.8495 19.5816 19.5816C19.8495 19.3137 20 18.9503 20 18.5714V1.42857C20 1.04969 19.8495 0.686328 19.5816 0.418419C19.3137 0.15051 18.9503 0 18.5714 0ZM17.1429 2.85714V8.57143H11.4286V2.85714H17.1429ZM8.57143 2.85714V8.57143H2.85714V2.85714H8.57143ZM2.85714 17.1429V11.4286H8.57143V17.1429H2.85714ZM11.4286 17.1429V11.4286H17.1429V17.1429H11.4286Z" fill="#021E4F"/>
    </svg>
);

export default RotationIcon;
